module.exports = __webpack_public_path__ + "img/btcd.8586e60f.svg";